import { useEffect, useState } from 'react';
import { api, ErreurApi } from '../api.js';
import { tokens } from '../tokens.js';
import {
  BoiteErreur, labelChamp, inputBase,
  boutonPrincipal, formaterDateLongue,
} from '../helpers.jsx';
import { Save, Sliders } from 'lucide-react';

export function AdminParametres() {
  const [params, setParams]   = useState([]);
  const [valeurs, setValeurs] = useState({});
  const [chargement, setCh]   = useState(true);
  const [erreur, setErreur]   = useState('');
  const [enSauve, setSauve]   = useState(false);
  const [retour, setRetour]   = useState(null);

  function recharger() {
    setCh(true);
    api.get('/admin/parametres')
      .then(d => {
        const ps = d.parametres || [];
        setParams(ps);
        setValeurs(Object.fromEntries(ps.map(p => [p.cle, p.valeur])));
      })
      .catch(e => setErreur(e.message))
      .finally(() => setCh(false));
  }
  useEffect(recharger, []);

  function modifier(cle, val) {
    setValeurs(v => ({ ...v, [cle]: val }));
  }

  async function sauver() {
    setSauve(true); setErreur(''); setRetour(null);
    try {
      await api.put('/admin/parametres', valeurs);
      setRetour({ ok: true, msg: 'Paramètres enregistrés' });
      recharger();
    } catch (e) {
      setRetour({ ok: false, msg: e instanceof ErreurApi ? e.message : 'Erreur' });
    } finally { setSauve(false); }
  }

  const modifie = params.some(p => String(p.valeur) !== String(valeurs[p.cle] ?? ''));

  return (
    <div>
      <div style={{ marginBottom: 18 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 600, color: tokens.ink }}>
          Paramètres
        </h2>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: tokens.inkSoft }}>
          Seuils utilisés par le tableau de bord et les calculs de KPI.
        </p>
      </div>

      {erreur && <BoiteErreur message={erreur} />}
      {chargement && <div style={etat}>Chargement…</div>}

      {!chargement && params.length > 0 && (
        <div style={{
          background: tokens.surface,
          border: `1px solid ${tokens.border}`,
          borderRadius: 10,
          padding: 22,
          maxWidth: 600,
        }}>
          <h3 style={{
            margin: '0 0 18px', fontSize: 12, fontWeight: 600,
            color: tokens.inkSoft, textTransform:'uppercase', letterSpacing: 0.5,
            display:'flex', alignItems:'center', gap: 6,
          }}>
            <Sliders size={14} /> Tableau de bord — seuils
          </h3>

          {params.map(p => (
            <div key={p.cle} style={{ marginBottom: 18 }}>
              <label style={labelChamp}>{p.libelle || p.cle}</label>
              <div style={{ display:'flex', alignItems:'center', gap: 10 }}>
                <input
                  type={p.type === 'entier' ? 'number' : 'text'}
                  value={valeurs[p.cle] ?? ''}
                  onChange={(e) => modifier(p.cle, e.target.value)}
                  min={1}
                  max={365}
                  style={{ ...inputBase, width: 120 }}
                />
                <span style={{ fontSize: 12, color: tokens.inkSoft }}>
                  {p.type === 'entier' ? 'jours' : ''}
                </span>
              </div>
              {p.description && (
                <p style={{
                  margin: '6px 0 0', fontSize: 11, color: tokens.inkMuted, lineHeight: 1.4,
                }}>
                  {p.description}
                </p>
              )}
            </div>
          ))}

          {retour && (
            <div style={{
              padding: '10px 12px', borderRadius: 6, fontSize: 13, marginBottom: 12,
              background: retour.ok ? tokens.successBg : tokens.dangerBg,
              color:      retour.ok ? tokens.success  : tokens.danger,
            }}>
              {retour.msg}
            </div>
          )}

          <button
            onClick={sauver}
            disabled={enSauve || !modifie}
            style={{ ...boutonPrincipal, opacity: modifie ? 1 : 0.5 }}
          >
            <Save size={14} /> {enSauve ? 'Enregistrement…' : 'Enregistrer'}
          </button>

          {params[0]?.mis_a_jour_le && (
            <p style={{ marginTop: 14, fontSize: 11, color: tokens.inkMuted }}>
              Dernière mise à jour : {formaterDateLongue(params[0].mis_a_jour_le)}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

const etat = {
  background: tokens.surface,
  border: `1px solid ${tokens.border}`,
  borderRadius: 10,
  padding: 32, textAlign:'center', color: tokens.inkSoft, fontSize: 14,
};
